import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { discountCategoryQueries } from '@/services/discount-management/discount-category.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useManageDiscountCategory = () => {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation('manageDiscountCategory', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: discountCategoryQueries.all() });
    },
    onError: (res) => {
      toast.error(res.message);
    },
  });
  return { mutateAsync };
};

export const useUpdateDiscountCategoryStatus = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation('manageCategoryStatus', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: discountCategoryQueries.all() });
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync, isPending };
};
